import type { Mission } from '../missions.ts'

export const ojp: Mission = {
  id: "ojp",
  name: "Office of Justice Programs",
  short: "OJP",
  call: "Justice Programs",
  kind: "subagency",
  parent: "doj",
  url: "https://www.ojp.gov/",
  established: 1984,
  palette: {
    primary: "#003263",
    secondary: "#7d4802",
    accent: "#febe10",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:US-OfficeOfJusticePrograms-Seal.svg",
  },
  motif: "hands",
  mission: {
    text: "To provide federal leadership, funding, and other critical resources to directly support law enforcement, combat violent crime, protect American children, and provide services to American crime victims.",
    url: "https://www.ojp.gov/about",
  },
  fact: {
    text: "OJP is the largest grantmaking component of the Department of Justice and houses its criminal and juvenile justice-related science, statistics, and programmatic agencies.",
    url: "https://www.ojp.gov/about",
  },
  seal: {
    file: "public/seals/ojp.png",
    source: "https://commons.wikimedia.org/wiki/File:US-OfficeOfJusticePrograms-Seal.svg",
  },
  identifier: {
    about: "https://www.ojp.gov/about",
    accessibility: "https://www.justice.gov/accessibility/accessibility-statement",
    foia: "https://www.ojp.gov/program/ojp-freedom-information-act/foia-overview",
    noFear: "https://www.justice.gov/jmd/eeo-program-status-report",
    oig: "https://oig.justice.gov/",
    performance: "https://www.justice.gov/doj/budget-and-performance",
    privacy: "https://www.justice.gov/doj/privacy-policy",
  },
}
